import React from 'react';
import { PAGES } from '../seoPages';
import SeoPage from './SeoPage';

function FAQ() {
  return <SeoPage page={PAGES.faq} />;
}

export default FAQ;
